export default "__VITE_ASSET__CkDdypZy__"